import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom';
import '../styles/globals.css'
import { Toaster } from 'sonner';


ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
  <React.StrictMode>
    <App />
    <Toaster position="bottom-right" richColors />
    
  </React.StrictMode>
  </BrowserRouter>
)